import { useNavigationStore } from "~/app/stores/navigation";
import { Titan } from "~/services/scopely/scopelyId";
import type { AnalyticsEventMap, SysUIParams } from "./tracker";

export function useAnalyticsTracker<K extends keyof AnalyticsEventMap>(
  eventName: K,
): (params: AnalyticsEventMap[K]) => void {
  const { analyticsPrevLocation, setAnalyticsPrevLocation } = useNavigationStore();

  return (params) => {
    let finalParams: SysUIParams | Record<string, unknown> = params as SysUIParams;

    if (eventName === "sys.ui") {
      const defaultParams: Partial<SysUIParams> = {
        screen_id: "webstore",
      };

      finalParams = { ...defaultParams, ...params };
      finalParams = {
        ...finalParams,
        previous_screen_id: analyticsPrevLocation.id,
        previous_screen_name: analyticsPrevLocation.name,
        previous_screen_category: analyticsPrevLocation.category,
      };
    }

    const normalizedParameters = Object.fromEntries(
      Object.entries(finalParams).map(([key, value]) => [key, value || null]),
    );

    Titan.SendEvent({ name: eventName, parameters: normalizedParameters });
    setAnalyticsPrevLocation({
      id: normalizedParameters.screen_id,
      name: normalizedParameters.screen_name,
      category: normalizedParameters.screen_category
    });
  };
}
